import { render, staticRenderFns } from "./InterestMarksContent.vue?vue&type=template&id=083cfb8f&scoped=true"
import script from "./InterestMarksContent.vue?vue&type=script&lang=js"
export * from "./InterestMarksContent.vue?vue&type=script&lang=js"
import style0 from "./InterestMarksContent.vue?vue&type=style&index=0&id=083cfb8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083cfb8f",
  null
  
)

export default component.exports